import React from 'react';

import { Container, TermsText } from './styles';

const Terms: React.FC = () => {
  return (
    <Container>
      <TermsText>
        <h3>Termos e Condições </h3>
        <p>Bem-vindo ao Circle!</p>
        <p>
          Estes termos e condições descrevem as regras e regulamentos para o uso
          do site da Sharply, localizado em https://circleweb.netlify.app/.
        </p>
        <p>
          Ao acessar este site, assumimos que você aceita estes termos e
          condições. Não continue a usar a plataforma Circle se não concordar em
          tomar todos os termos e condições indicados nesta página.
        </p>
        <h4>Licença:</h4>
        <p>
          Salvo indicação em contrário, a Sharply e/ou seus licenciadores são os
          proprietários dos direitos de propriedade intelectual para todo o
          material no Circle. Todos os direitos de propriedade intelectual são
          reservados. Você pode acessar isso de Circle para seu uso pessoal
          sujeito a restrições estabelecidas em estes termos e condições.
        </p>
        <p>Você não deve:</p>
        <ul>
          <li>Copiar ou republicar material do Circle</li>
          <li>Vender, alugar ou licenciar material da Circle</li>
          <li>Reproduzir, duplicar ou copiar material do Circle</li>
          <li>Redistribuir conteúdo do Circle</li>
        </ul>
        <p>Este Contrato terá início nesta data.</p>
        <p>
          Partes deste site oferecem aos usuários a oportunidade de postar e
          trocar opiniões e informações em determinadas áreas do site. Sharply
          não filtra, edita, publica ou revisa comentários antes destes
          aparecerem no site. Os comentários não refletem os pontos de vista e
          opiniões de Sharply, seus agentes e/ou afiliados. Os comentários
          refletem as opiniões e opiniões da pessoa que publica seus pontos de
          vista e opiniões. Na medida permitida pelas leis aplicáveis, a Sharply
          não será responsável pelos comentários ou qualquer responsabilidade,
          danos ou despesas causados e/ou sofrido como resultado de qualquer uso
          e/ou publicação de e/ou aparência dos comentários neste site.
        </p>
        <p>
          A Sharply reserva o direito de monitorar todos os comentários e
          remover quaisquer comentários que podem ser considerados
          inapropriados, ofensivos ou violação destes Termos e Condições.
        </p>
        <p>Você garante e declara que:</p>
        <ul>
          <li>
            Você tem o direito de postar os comentários em nosso site e ter
            todos os licenças e consentimentos necessários para fazê-lo;
          </li>
          <li>
            Os comentários não invadem nenhum direito de propriedade
            intelectual, incluindo, sem limitação, direitos autorais, patentes
            ou marcas comerciais de qualquer terceiro;
          </li>
          <li>
            Os comentários não contêm nenhum conteúdo difamatório, calunioso,
            ofensivo, material indecente ou ilegal, que é uma invasão de
            privacidade.
          </li>
          <li>
            Os comentários não serão usados para solicitar ou promover negócios
            ou costume ou atividades comerciais atuais ou atividade ilegal.
          </li>
        </ul>
        <p>
          Você concede à Sharply uma licença não exclusiva para usar,
          reproduzir, editar e autorizar outros a usar, reproduzir e editar
          qualquer um de seus comentários em toda e qualquer forma, formato ou
          mídia.
        </p>
        <h4>Hyperlinks para nosso conteúdo:</h4>
        <p>
          As seguintes organizações podem se conectar ao nosso site sem prévia
          aprovação por escrito:
        </p>
        <ul>
          <li>Agências governamentais;</li>
          <li>Mecanismos de pesquisa;</li>
          <li>Organizações de notícias;</li>
          <li>
            Os distribuidores de diretórios on-line podem vincular-se ao nosso
            site da mesma maneira que vinculam aos sites de outras empresas
            listadas; e
          </li>
          <li>
            Empresas credenciadas em todo o sistema, exceto organizações sem
            fins lucrativos, shopping centers de caridade e grupos de angariação
            de fundos de caridade que não podem ter links para nosso site.
          </li>
        </ul>
        <p>
          Essas organizações podem criar links para nossa página inicial,
          publicações ou outras informações do site, desde que o link: (a) não
          seja de forma alguma enganoso; (b) não implique falsamente patrocínio,
          endosso ou aprovação da parte vinculada e seus produtos e/ou serviços;
          e (c) se enquadre no contexto do site da parte vinculada.
        </p>
        <p>
          Podemos considerar e aprovar outras solicitações de link dos seguintes
          tipos de organizações:
        </p>
        <ul>
          <li>
            Fontes de informações de consumidores e/ou negócios comumente
            conhecidas;
          </li>
          <li>Sites da comunidade ponto.com;</li>
          <li>
            Associações ou outros grupos que representam instituições de
            caridade;
          </li>
          <li>Distribuidores de diretórios on-line;</li>
          <li>Portais de internet;</li>
          <li>Empresas de contabilidade, advocacia e consultoria; e</li>
          <li>Instituições de ensino e associações comerciais.</li>
        </ul>
        <p>
          Aprovaremos solicitações de links dessas organizações se decidirmos
          que: (a) o link não nos faria parecer desfavorável a nós mesmos ou aos
          nossos negócios credenciados; (b) a organização não possui registros
          negativos conosco; (c) o benefício para nós da visibilidade do
          hiperlink compensa a ausência da Sharply; e (d) o link está no
          contexto de informações gerais sobre recursos.
        </p>
        <p>
          Essas organizações podem criar links para nossa página inicial, desde
          que o link: (a) não seja enganoso de forma alguma; (b) não implique
          falsamente patrocínio, endosso ou aprovação da parte vinculada e seus
          produtos ou serviços; e (c) se enquadre no contexto do site da parte
          vinculada.
        </p>
        <p>
          Se você é uma das organizações listadas no parágrafo 2 acima e está
          interessado em se conectar ao nosso site, você deve nos informar
          enviando um e-mail para Sharply. Inclua seu nome, nome da sua
          organização, informações de contato, bem como o URL do seu site, uma
          lista de todos os URLs dos quais você pretende vincular ao nosso site
          e uma lista dos URLs do nosso site para os quais você gostaria de
          link. Aguarde 2-3 semanas por uma resposta.
        </p>
        <p>
          As organizações aprovadas podem criar links para o nosso site da
          seguinte forma:
        </p>
        <ul>
          <li>Pelo uso de nosso nome corporativo; ou</li>
          <li>
            Pelo uso do localizador uniforme de recursos que está sendo
            vinculado; ou
          </li>
          <li>
            O uso de qualquer outra descrição do nosso site vinculado a isso faz
            sentido dentro do contexto e formato do conteúdo no site da parte
            vinculante.
          </li>
        </ul>
        <p>
          Não será permitido o uso do logotipo da Sharply ou de outras obras de
          arte para vincular sem um contrato de licença de marca registrada.
        </p>
        <h4>Responsabilidade do conteúdo:</h4>
        <p>
          Não nos responsabilizamos por qualquer conteúdo que apareça no site.
          Você concorda em nos proteger e nos defender contra todas as
          reivindicações levantadas no site. Nenhum link(s) deve(m) aparecer em
          qualquer site que possa ser interpretado como difamatório, obsceno ou
          criminoso, ou que infrinja, viole de outra forma ou defenda a violação
          ou outra violação de quaisquer direitos de terceiros.
        </p>
        <h4>Reserva de Direitos:</h4>
        <p>
          Reservamo-nos o direito de solicitar que você remova todos os links ou
          qualquer link específico para o nosso site. Você aprova a remoção
          imediata de todos os links para nosso site mediante solicitação.
          Também nos reservamos o direito de alterar estes termos e condições e
          sua política de vinculação a qualquer momento. Ao vincular
          continuamente ao nosso site, você concorda em se comprometer e seguir
          estes termos e condições de vinculação.
        </p>
        <h4>Remoção de links do nosso site:</h4>
        <p>
          Se você encontrar algum link em nosso site que seja ofensivo por
          qualquer motivo, você pode entrar em contato e nos informar a qualquer
          momento. Consideraremos solicitações para remover links, mas não somos
          obrigados a responder a você diretamente.
        </p>
        <p>
          Não garantimos que as informações contidas neste site estejam
          corretas. Não garantimos sua integridade ou precisão, nem prometemos
          garantir que o site permaneça disponível ou que o material no site
          seja mantido atualizado.
        </p>
        <h4>Isenção de responsabilidade:</h4>
        <p>
          Os serviços indicados nessa plataforma são indicados por membros da
          mesma. Contudo, a Sharply não se responsabiliza pela qualidade dos
          serviços aqui encontrados.
        </p>
        <p>
          Na extensão máxima permitida pela lei aplicável, excluímos todas as
          representações, garantias e condições relacionadas ao nosso site e ao
          uso deste site. Nada neste aviso legal irá:
        </p>
        <ul>
          <li>
            Limitar ou excluir nossa ou sua responsabilidade por morte ou danos
            pessoais;
          </li>
          <li>
            Limitar ou excluir nossa ou sua responsabilidade por fraude ou
            deturpação fraudulenta;
          </li>
          <li>
            Limitar qualquer uma de nossas ou suas responsabilidades de qualquer
            forma que não seja permitida pela lei aplicável; ou
          </li>
          <li>
            Excluir qualquer uma de nossas ou suas responsabilidades que não
            possam ser excluídas pela lei aplicável.
          </li>
        </ul>
        <p>
          As limitações e proibições de responsabilidade estabelecidas nesta
          Seção e em outras partes desta isenção de responsabilidade: (a) estão
          sujeitas ao parágrafo anterior; e (b) reger todas as responsabilidades
          decorrentes da isenção de responsabilidade, incluindo
          responsabilidades decorrentes de contrato, delito e violação de dever
          legal.
        </p>
        <p>
          Desde que o site e as informações e serviços no site sejam fornecidos
          gratuitamente, não seremos responsáveis por quaisquer perdas ou danos
          de qualquer natureza.
        </p>
      </TermsText>
    </Container>
  );
};

export default Terms;
